export default __webpack_public_path__ + "static/media/logout.ee6b357d.svg";